module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "registry"
  }, [_c('div', {
    staticClass: "content-layout"
  }, [_c('div', {
    staticClass: "column column__large"
  }, [(!_vm.$store.state.loadingRegistry && _vm.$store.state.carData.registry.LaaneDokumenter.length > 0) ? _c('div', {
    staticClass: "block"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body narrow align-top"
  }, [_vm._v("\n                    Vær opmærksom på, at der er registreret pant i dette køretøj. Det betyder, at den nuværende ejer skylder penge væk i køretøjet. Vær sikker på, at sælger får indfriet gælden inden salg.\n                    "), _c('hr'), _vm._v(" "), _vm._l((_vm.debitors), function(debitor) {
    return _c('line-data', {
      key: debitor.formattedName,
      attrs: {
        "title": "Debitor",
        "value": debitor.formattedName
      }
    }, [_c('span', {
      staticClass: "extra",
      attrs: {
        "slot": "extra"
      },
      slot: "extra"
    }, [_vm._v("\n                            (" + _vm._s(debitor.age) + " år)\n                        ")])])
  }), _vm._v(" "), (_vm.$store.state.carData.registry.LaaneDokumenter[0].Underpanthaver) ? _c('line-data', {
    attrs: {
      "title": "Underpanthaver",
      "value": _vm.$store.state.carData.registry.LaaneDokumenter[0].Underpanthaver
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$store.state.carData.registry.LaaneDokumenter[0].Underpanthaver && _vm.$store.state.carData.registry.LaaneDokumenter[0].Kreditorer[0]) ? _c('line-data', {
    attrs: {
      "title": "Kreditor",
      "value": _vm.$store.state.carData.registry.LaaneDokumenter[0].Kreditorer[0].Navn
    }
  }) : _vm._e(), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Stelnummer",
      "value": _vm.$store.state.carData.general.StelNr
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Type",
      "value": _vm.$store.state.carData.registry.LaaneDokumenter[0].DokumentType
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Dato",
      "value": _vm._f("moment")(_vm.registryDate, 'D. MMMM YYYY')
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Hovedstol",
      "value": _vm._f("currency")(_vm.$store.state.carData.registry.LaaneDokumenter[0].HovedStol),
      "suffix": "kr."
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Rente",
      "value": _vm.$store.state.carData.registry.LaaneDokumenter[0].InterestRate,
      "suffix": "%"
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Særlige vilkår",
      "value": _vm.$store.state.carData.registry.LaaneDokumenter[0].SaerligeLaanevilkaar
    }
  }), _vm._v(" "), _c('line-data', {
    attrs: {
      "title": "Løbenummer",
      "value": _vm.$store.state.carData.registry.LaaneDokumenter[0].LoebeNummer
    }
  }), _vm._v(" "), _vm._l((_vm.$store.state.carData.registry.LaaneDokumenter[0].TillaegsTekster), function(warning, index) {
    return (index === 0) ? _c('line-data', {
      key: warning,
      attrs: {
        "title": "Bemærkninger",
        "value": warning
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.$store.state.carData.registry.LaaneDokumenter[0].TillaegsTekster), function(warning, index) {
    return (index !== 0) ? _c('line-data', {
      key: warning,
      attrs: {
        "title": "",
        "value": warning
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1)], 2)]) : _c('div', {
    staticClass: "block"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._v("\n                    Ifølge de offentlige oplysninger, som vi indhenter, er der ingen restgæld (pant) i dette køretøj.\n                    "), _c('br'), _c('br'), _vm._v("\n                    Vi opdaterer vores oplysninger en gang i døgnet\n                    "), _c('br'), _c('br'), _vm._v("\n                    Tjek venligst "), _c('a', {
    attrs: {
      "href": "https://www.tinglysning.dk/t/#/top/forespoerg/bilbogen",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("www.tingstyrelsen.dk")]), _vm._v(" for de nyeste oplysninger.\n                    "), _c('br'), _vm._v("\n                    Du skal bruge køretøjets stelnummer, som er "), _c('b', [_vm._v(_vm._s(_vm.$store.state.carData.general.StelNr))]), _vm._v(".\n                ")])])]), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fal fa-exclamation fa-fw"
  }), _vm._v("\n                    Der er registreret restgæld i dette køretøj\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meta",
    staticStyle: {
      "opacity": ".5"
    }
  }, [_c('div', [_vm._v("\n                            Oplysningerne opdateres en gang i døgnet.\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fal fa-check fa-fw"
  }), _vm._v("\n                    Ingen restgæld registreret i dette køretøj\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column column__small"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    BilBogen\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._v("\n                    BilBogen er et offentligt register, hvor kreditorer kan registrere pant og udlæg over motorkøretøjer (bil, motorcykel m.fl.).\n                    "), _c('br'), _c('br'), _vm._v("\n                    Alle oplysninger i BilBogen er offentlige og kan findes på "), _c('a', {
    attrs: {
      "href": "https://tinglysning.dk",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("www.tinglysning.dk")]), _vm._v(".\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Restgæld / pant\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._v("\n                    Kreditorer, som låner penge til køb af motorkøretøjer, kan få stillet sikkerhed i motorkøretøjet (pant) for at sikre, at debitor betaler gælden. Hvis gælden misligholdes, kan kreditor sælge bilen for at inddrive det skyldige beløb.\n                    "), _c('br'), _c('br'), _vm._v("\n                    Der er intet farligt i at købe en brugt bil med restgæld / pant. Du skal blot sikre dig, at sælger indfrier denne gæld ved købet.\n                ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36320e40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/search/pages/registry.vue
// module id = 349
// module chunks = 1